import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
    code: 'Email.NonFcrGroup'
})
export class EmailNonFcrGroup {
    @GenericLookup({
        code: 'Email.NonFcrGroup.EmailAddress'
    })
    static emailAddress: string;

    @GenericLookup({
        code: 'Email.NonFcrGroup.CustomerId'
    })
    static customerId: number;
}
